<script>
  let {
    assetsPath = '/',
    onAiMounted = () => {},
    onArtboardChange = () => {},
  } = $props();
  import { onMount, untrack } from 'svelte';
  let aiBox;
  let aiBoxWidth = $state(undefined);
  let allArtboards = $state([]);
  let activeArtboard = $state(undefined);
  onMount(() => {
    allArtboards = Array.from(aiBox.querySelectorAll('.g-artboard'));
    onAiMounted();
  });
  $effect(() => {
    if (aiBoxWidth) {
      const currentArtboard = allArtboards.filter((artboard) => {
        const minWidth = parseFloat(artboard.dataset.minWidth);
        const maxWidth = parseFloat(artboard.dataset.maxWidth) || Infinity;
        return minWidth <= aiBoxWidth && maxWidth >= aiBoxWidth;
      })[0];
      if (currentArtboard?.id !== activeArtboard?.id) {
        activeArtboard = untrack(() => currentArtboard);
        onArtboardChange(activeArtboard);
      }
    }
  });
</script>

<div
  id="g-post14-teheranoil-box"
  class="ai2svelte"
  bind:this={aiBox}
  bind:clientWidth={aiBoxWidth}
>
  <!-- Artboard: xs -->
  <div
    id="g-post14-teheranoil-xs"
    class="g-artboard"
    style="max-width: 509px;aspect-ratio: 0.59245960502693;"
    data-aspect-ratio="0.592"
    data-min-width="0"
    data-max-width="509"
  >
    <div
      id="g-post14-teheranoil-xs-img"
      class="g-post14-teheranoil-xs-img g-aiImg"
      alt=""
      style="background-image: url({assetsPath.replace(
        new RegExp('/([^/.]+)$'),
        '/$1/'
      ) || '/'}images/graphics/post14-teheranoil-xs.jpg);"
    ></div>
    <div
      id="g-ai0-2"
      class="g-text g-aiAbs g-aiPointText"
      style="top:9.9712%;margin-top:-11.5px;left:77.0344%;width:58px;"
    >
      <p class="g-pstyle1">Tehran</p>
    </div>
    <div
      id="g-ai0-3"
      class="g-text g-aiAbs g-aiPointText"
      style="top:12.6642%;margin-top:-11.5px;left:81.9113%;width:50px;"
    >
      <p class="g-pstyle1">IRAN</p>
    </div>
    <div
      id="g-ai0-10"
      class="g-text g-aiAbs g-aiPointText"
      style="top:96.0648%;margin-top:-8.1px;left:14.8784%;margin-left:-26.5px;width:53px;"
    >
      <p class="g-pstyle8">10km</p>
    </div>
    <div
      id="g-ai0-1"
      class="g-text g-aiAbs g-aiPointText"
      style="top:6.0364%;margin-top:-15.6px;left:6.9297%;width:165px;"
    >
      <p class="g-pstyle0">Refineries and oil</p>
      <p class="g-pstyle0">storage sites attacked</p>
    </div>
    <div
      id="g-ai0-6"
      class="g-shadowtext g-aiAbs g-aiPointText"
      style="top:46.3639%;margin-top:-8.2px;left:42.6531%;width:88px;"
    >
      <p class="g-pstyle4">Tehran</p>
    </div>
    <div
      id="g-ai0-7"
      class="g-shadowtext g-aiAbs g-aiPointText"
      style="top:46.7006%;margin-top:-8.1px;left:3.4437%;width:123px;"
    >
      <p class="g-pstyle5">Kuhak oil depot</p>
    </div>
    <div
      id="g-ai0-8"
      class="g-shadowtext g-aiAbs g-aiPointText"
      style="top:64.9233%;margin-top:-15.6px;left:26.0065%;width:138px;"
    >
      <p class="g-pstyle6">Air strikes<span class="g-cstyle0"> </span></p>
      <p class="g-pstyle7">(Feb. 28- March 8)</p>
    </div>
    <div
      id="g-ai0-9"
      class="g-shadowtext g-aiAbs g-aiPointText"
      style="top:79.5552%;margin-top:-8.1px;left:64.7431%;margin-left:-68px;width:136px;"
    >
      <p class="g-pstyle3">Several oil depots</p>
    </div>
    <div
      id="g-ai0-4"
      class="g-shadowtext g-aiAbs g-aiPointText"
      style="top:26.8622%;margin-top:-15.6px;right:4.6125%;width:97px;"
    >
      <p class="g-pstyle2">Aghdasiyeh</p>
      <p class="g-pstyle2">oil storage</p>
    </div>
    <div
      id="g-ai0-5"
      class="g-shadowtext g-aiAbs g-aiPointText"
      style="top:31.0812%;margin-top:-8.1px;left:28.3153%;margin-left:-74px;width:148px;"
    >
      <p class="g-pstyle3">Shahran oil refinery</p>
    </div>
  </div>
  <!-- Artboard: sm -->
  <div
    id="g-post14-teheranoil-sm"
    class="g-artboard"
    style="min-width: 510px;max-width: 659px;aspect-ratio: 0.92391304347826;"
    data-aspect-ratio="0.924"
    data-min-width="510"
    data-max-width="659"
  >
    <div
      id="g-post14-teheranoil-sm-img"
      class="g-post14-teheranoil-sm-img g-aiImg"
      alt=""
      style="background-image: url({assetsPath.replace(
        new RegExp('/([^/.]+)$'),
        '/$1/'
      ) || '/'}images/graphics/post14-teheranoil-sm.jpg);"
    ></div>
    <div
      id="g-ai1-2"
      class="g-text g-aiAbs g-aiPointText"
      style="top:10.0615%;margin-top:-11.5px;left:84.4344%;width:58px;"
    >
      <p class="g-pstyle1">Tehran</p>
    </div>
    <div
      id="g-ai1-3"
      class="g-text g-aiAbs g-aiPointText"
      style="top:12.7789%;margin-top:-11.5px;left:87.59%;width:50px;"
    >
      <p class="g-pstyle1">IRAN</p>
    </div>
    <div
      id="g-ai1-11"
      class="g-text g-aiAbs g-aiPointText"
      style="top:96.935%;margin-top:-8.1px;left:10.2765%;margin-left:-26.5px;width:53px;"
    >
      <p class="g-pstyle7">10km</p>
    </div>
    <div
      id="g-ai1-1"
      class="g-text g-aiAbs g-aiPointText"
      style="top:7.4573%;margin-top:-8.2px;left:3.7174%;width:299px;"
    >
      <p class="g-pstyle0">Refineries and oil storage sites attacked</p>
    </div>
    <div
      id="g-ai1-6"
      class="g-shadowtext g-aiAbs g-aiPointText"
      style="top:41.5077%;margin-top:-8.1px;left:1.7338%;width:133px;"
    >
      <p class="g-pstyle3">Fardis oil storage</p>
    </div>
    <div
      id="g-ai1-7"
      class="g-shadowtext g-aiAbs g-aiPointText"
      style="top:46.7838%;margin-top:-8.2px;left:59.4568%;width:88px;"
    >
      <p class="g-pstyle4">Tehran</p>
    </div>
    <div
      id="g-ai1-8"
      class="g-shadowtext g-aiAbs g-aiPointText"
      style="top:47.3048%;margin-top:-8.1px;left:43.314%;margin-left:-61.5px;width:123px;"
    >
      <p class="g-pstyle2">Kuhak oil depot</p>
    </div>
    <div
      id="g-ai1-9"
      class="g-shadowtext g-aiAbs g-aiPointText"
      style="top:67.6852%;margin-top:-15.6px;left:10.1951%;width:138px;"
    >
      <p class="g-pstyle5">Air strikes<span class="g-cstyle0"> </span></p>
      <p class="g-pstyle6">(Feb. 28- March 8)</p>
    </div>
    <div
      id="g-ai1-10"
      class="g-shadowtext g-aiAbs g-aiPointText"
      style="top:80.457%;margin-top:-8.1px;left:73.0231%;margin-left:-68px;width:136px;"
    >
      <p class="g-pstyle2">Several oil depots</p>
    </div>
    <div
      id="g-ai1-4"
      class="g-shadowtext g-aiAbs g-aiPointText"
      style="top:27.649%;margin-top:-15.6px;left:89.6163%;margin-left:-48.5px;width:97px;"
    >
      <p class="g-pstyle2">Aghdasiyeh</p>
      <p class="g-pstyle2">oil storage</p>
    </div>
    <div
      id="g-ai1-5"
      class="g-shadowtext g-aiAbs g-aiPointText"
      style="top:31.3628%;margin-top:-8.1px;left:50.1792%;margin-left:-74px;width:148px;"
    >
      <p class="g-pstyle2">Shahran oil refinery</p>
    </div>
  </div>
  <!-- Artboard: md -->
  <div
    id="g-post14-teheranoil-md"
    class="g-artboard"
    style="min-width: 660px;max-width: 929px;aspect-ratio: 1.3549887679625;"
    data-aspect-ratio="1.355"
    data-min-width="660"
    data-max-width="929"
  >
    <div
      id="g-post14-teheranoil-md-img"
      class="g-post14-teheranoil-md-img g-aiImg"
      alt=""
      style="background-image: url({assetsPath.replace(
        new RegExp('/([^/.]+)$'),
        '/$1/'
      ) || '/'}images/graphics/post14-teheranoil-md.jpg);"
    ></div>
    <div
      id="g-ai2-2"
      class="g-text g-aiAbs g-aiPointText"
      style="top:16.0272%;margin-top:-12.1px;left:86.7097%;width:56px;"
    >
      <p class="g-pstyle1">Tehran</p>
    </div>
    <div
      id="g-ai2-3"
      class="g-text g-aiAbs g-aiPointText"
      style="top:19.3184%;margin-top:-12.1px;left:89.2392%;width:46px;"
    >
      <p class="g-pstyle2">IRAN</p>
    </div>
    <div
      id="g-ai2-11"
      class="g-text g-aiAbs g-aiPointText"
      style="top:95.8924%;margin-top:-8.1px;left:7.5934%;margin-left:-26.5px;width:53px;"
    >
      <p class="g-pstyle8">10km</p>
    </div>
    <div
      id="g-ai2-1"
      class="g-text g-aiAbs g-aiPointText"
      style="top:5.1662%;margin-top:-8.2px;left:4.0137%;width:317px;"
    >
      <p class="g-pstyle0">Oil refineries and oil storage sites attacked</p>
    </div>
    <div
      id="g-ai2-6"
      class="g-shadowtext g-aiAbs g-aiPointText"
      style="top:46.0127%;margin-top:-8.1px;left:12.4985%;margin-left:-66.5px;width:133px;"
    >
      <p class="g-pstyle3">Fardis oil storage</p>
    </div>
    <div
      id="g-ai2-7"
      class="g-shadowtext g-aiAbs g-aiPointText"
      style="top:52.1717%;margin-top:-8.1px;left:44.4944%;margin-left:-61.5px;width:123px;"
    >
      <p class="g-pstyle3">Kuhak oil depot</p>
    </div>
    <div
      id="g-ai2-8"
      class="g-shadowtext g-aiAbs g-aiPointText"
      style="top:63.3005%;margin-top:-8.3px;left:38.6133%;width:95px;"
    >
      <p class="g-pstyle5">Tehran</p>
    </div>
    <div
      id="g-ai2-9"
      class="g-shadowtext g-aiAbs g-aiPointText"
      style="top:77.7317%;margin-top:-16.6px;left:16.7735%;width:138px;"
    >
      <p class="g-pstyle6">Air strikes<span class="g-cstyle0"> </span></p>
      <p class="g-pstyle7">(Feb. 28- March 8)</p>
    </div>
    <div
      id="g-ai2-10"
      class="g-shadowtext g-aiAbs g-aiPointText"
      style="top:93.232%;margin-top:-8.1px;left:68.8522%;margin-left:-68px;width:136px;"
    >
      <p class="g-pstyle3">Several oil depots</p>
    </div>
    <div
      id="g-ai2-4"
      class="g-shadowtext g-aiAbs g-aiPointText"
      style="top:33.284%;margin-top:-8.1px;left:51.8629%;margin-left:-74px;width:148px;"
    >
      <p class="g-pstyle3">Shahran oil refinery</p>
    </div>
    <div
      id="g-ai2-5"
      class="g-shadowtext g-aiAbs g-aiPointText"
      style="top:40.3669%;margin-top:-15.6px;left:79.1038%;width:97px;"
    >
      <p class="g-pstyle4">Aghdasiyeh</p>
      <p class="g-pstyle4">oil storage</p>
    </div>
  </div>
  <!-- Artboard: lg -->
  <div
    id="g-post14-teheranoil-lg"
    class="g-artboard"
    style="min-width: 930px;max-width: 1199px;aspect-ratio: 1.72750368074917;"
    data-aspect-ratio="1.728"
    data-min-width="930"
    data-max-width="1199"
  >
    <div
      id="g-post14-teheranoil-lg-img"
      class="g-post14-teheranoil-lg-img g-aiImg"
      alt=""
      style="background-image: url({assetsPath.replace(
        new RegExp('/([^/.]+)$'),
        '/$1/'
      ) || '/'}images/graphics/post14-teheranoil-lg.jpg);"
    ></div>
    <div
      id="g-ai3-2"
      class="g-text g-aiAbs g-aiPointText"
      style="top:11.9961%;margin-top:-13.6px;left:89.7887%;width:61px;"
    >
      <p class="g-pstyle1">Tehran</p>
    </div>
    <div
      id="g-ai3-3"
      class="g-text g-aiAbs g-aiPointText"
      style="top:15.332%;margin-top:-13.5px;left:91.8611%;width:50px;"
    >
      <p class="g-pstyle2">IRAN</p>
    </div>
    <div
      id="g-ai3-11"
      class="g-text g-aiAbs g-aiPointText"
      style="top:96.6995%;margin-top:-14.6px;left:7.2069%;margin-left:-26.5px;width:53px;"
    >
      <p class="g-pstyle8">10km</p>
    </div>
    <div
      id="g-ai3-1"
      class="g-text g-aiAbs g-aiPointText"
      style="top:2.631%;margin-top:-8.2px;left:2.5462%;width:299px;"
    >
      <p class="g-pstyle0">Refineries and oil storage sites attacked</p>
    </div>
    <div
      id="g-ai3-6"
      class="g-shadowtext g-aiAbs g-aiPointText"
      style="top:44.6112%;margin-top:-21.2px;left:12.1461%;width:140px;"
    >
      <p class="g-pstyle4">Fardis oil storage</p>
    </div>
    <div
      id="g-ai3-7"
      class="g-shadowtext g-aiAbs g-aiPointText"
      style="top:51.2983%;margin-top:-21.2px;left:41.6145%;margin-left:-64.5px;width:129px;"
    >
      <p class="g-pstyle3">Kuhak oil depot</p>
    </div>
    <div
      id="g-ai3-8"
      class="g-shadowtext g-aiAbs g-aiPointText"
      style="top:61.3829%;margin-top:-21.5px;left:35.4317%;width:106px;"
    >
      <p class="g-pstyle5">Tehran</p>
    </div>
    <div
      id="g-ai3-9"
      class="g-shadowtext g-aiAbs g-aiPointText"
      style="top:77.7681%;margin-top:-18.7px;left:19.3691%;width:145px;"
    >
      <p class="g-pstyle6">Air strikes<span class="g-cstyle0"> </span></p>
      <p class="g-pstyle7">(Feb. 28- March 8)</p>
    </div>
    <div
      id="g-ai3-10"
      class="g-shadowtext g-aiAbs g-aiPointText"
      style="top:93.65%;margin-top:-21.2px;left:58.3277%;width:143px;"
    >
      <p class="g-pstyle4">Several oil depots</p>
    </div>
    <div
      id="g-ai3-4"
      class="g-shadowtext g-aiAbs g-aiPointText"
      style="top:31.237%;margin-top:-21.2px;left:48.0945%;margin-left:-78px;width:156px;"
    >
      <p class="g-pstyle3">Shahran oil refinery</p>
    </div>
    <div
      id="g-ai3-5"
      class="g-shadowtext g-aiAbs g-aiPointText"
      style="top:34.0233%;margin-top:-21.2px;left:75.4692%;width:178px;"
    >
      <p class="g-pstyle4">Aghdasiyeh oil storage</p>
    </div>
  </div>
  <!-- Artboard: xl -->
  <div
    id="g-post14-teheranoil-xl"
    class="g-artboard"
    style="min-width: 1200px;aspect-ratio: 1.93548387096774;"
    data-aspect-ratio="1.935"
    data-min-width="1200"
  >
    <div
      id="g-post14-teheranoil-xl-img"
      class="g-post14-teheranoil-xl-img g-aiImg"
      alt=""
      style="background-image: url({assetsPath.replace(
        new RegExp('/([^/.]+)$'),
        '/$1/'
      ) || '/'}images/graphics/post14-teheranoil-xl.jpg);"
    ></div>
    <div
      id="g-ai4-2"
      class="g-text g-aiAbs g-aiPointText"
      style="top:50.0937%;margin-top:-9.6px;left:42.55%;width:194px;"
    >
      <p class="g-pstyle1">Secondary annotation @14px</p>
    </div>
    <div
      id="g-ai4-3"
      class="g-text g-aiAbs g-aiPointText"
      style="top:55.2416%;margin-top:-9.5px;left:42.55%;width:154px;"
    >
      <p class="g-pstyle2">Tertiary annotation @12px</p>
    </div>
    <div
      id="g-ai4-1"
      class="g-text g-aiAbs g-aiPointText"
      style="top:45.1071%;margin-top:-9.7px;left:42.55%;width:201px;"
    >
      <p class="g-pstyle0">Primary annotation @16px</p>
    </div>
  </div>
</div>

<!-- End ai2svelte - 2026-03-10 15:56 -->

<!-- Generated by ai2svelte v1.0.3 - 2026-03-10 15:56 -->
<!-- ai file: post14-teheranoil.ai -->
<style lang="scss">
  #g-post14-teheranoil-box {
    container-type: inline-size;
    container-name: g-post14-teheranoil-box;
  }
  #g-post14-teheranoil-box,
  #g-post14-teheranoil-box .g-artboard {
    margin: 0 auto;
  }
  #g-post14-teheranoil-box p {
    margin: 0;
  }
  #g-post14-teheranoil-box .g-aiAbs {
    position: absolute;
  }
  #g-post14-teheranoil-box .g-aiImg {
    position: absolute;
    top: 0;
    display: block;
    width: 100% !important;
    height: 100%;
    background-size: contain;
    background-repeat: no-repeat;
  }
  #g-post14-teheranoil-box .g-aiSymbol {
    position: absolute;
    box-sizing: border-box;
  }
  #g-post14-teheranoil-box .g-aiPointText p {
    white-space: nowrap;
  }
  #g-post14-teheranoil-box.g-aiPointText p {
    white-space: nowrap;
  }
  #g-post14-teheranoil-box {
    width: 100%;
    container-type: inline-size;
    @container (min-width:0px) and (max-width: 509px) {
      #g-post14-teheranoil-xs {
        display: block !important;
      }
    }
    @container (min-width:510px) and (max-width: 659px) {
      #g-post14-teheranoil-sm {
        display: block !important;
      }
    }
    @container (min-width:660px) and (max-width: 929px) {
      #g-post14-teheranoil-md {
        display: block !important;
      }
    }
    @container (min-width:930px) and (max-width: 1199px) {
      #g-post14-teheranoil-lg {
        display: block !important;
      }
    }
    @container (min-width:1200px) {
      #g-post14-teheranoil-xl {
        display: block !important;
      }
    }
  }
  #g-post14-teheranoil-xs {
    position: relative;
    overflow: hidden;
    display: none;
  }
  #g-post14-teheranoil-xs p {
    font-family: var(--theme-font-family-sans-serif), Knowledge, sans-serif;
    font-weight: regular;
    line-height: 15px;
    height: auto;
    opacity: 1;
    letter-spacing: 0em;
    font-size: 15px;
    text-align: left;
    color: rgb(64, 64, 64);
    text-transform: none;
    padding-bottom: 0;
    padding-top: 0;
    mix-blend-mode: normal;
    font-style: normal;
    position: static;
  }
  #g-post14-teheranoil-xs .g-pstyle0 {
    font-weight: 700;
    height: 15px;
  }
  #g-post14-teheranoil-xs .g-pstyle1 {
    font-weight: 300;
    line-height: 22px;
    height: 22px;
    font-size: 13px;
  }
  #g-post14-teheranoil-xs .g-pstyle2 {
    font-weight: 500;
    height: 15px;
    text-align: right;
  }
  #g-post14-teheranoil-xs .g-pstyle3 {
    font-weight: 500;
    height: 15px;
    text-align: center;
  }
  #g-post14-teheranoil-xs .g-pstyle4 {
    font-weight: 700;
    height: 15px;
    letter-spacing: 0.13em;
    font-size: 18px;
  }
  #g-post14-teheranoil-xs .g-pstyle5 {
    font-weight: 500;
    height: 15px;
  }
  #g-post14-teheranoil-xs .g-pstyle6 {
    font-weight: 700;
    height: 15px;
    color: rgb(161, 54, 48);
  }
  #g-post14-teheranoil-xs .g-pstyle7 {
    font-weight: 400;
    height: 15px;
    color: rgb(161, 54, 48);
  }
  #g-post14-teheranoil-xs .g-pstyle8 {
    font-weight: 400;
    height: 15px;
    font-size: 14px;
    text-align: center;
    color: rgb(93, 93, 93);
  }
  #g-post14-teheranoil-xs .g-cstyle0 {
    font-weight: 300;
  }
  #g-post14-teheranoil-sm {
    position: relative;
    overflow: hidden;
    display: none;
  }
  #g-post14-teheranoil-sm p {
    font-family: var(--theme-font-family-sans-serif), Knowledge, sans-serif;
    font-weight: regular;
    line-height: 15px;
    height: auto;
    opacity: 1;
    letter-spacing: 0em;
    font-size: 15px;
    text-align: left;
    color: rgb(64, 64, 64);
    text-transform: none;
    padding-bottom: 0;
    padding-top: 0;
    mix-blend-mode: normal;
    font-style: normal;
    position: static;
  }
  #g-post14-teheranoil-sm .g-pstyle0 {
    font-weight: 700;
    height: 15px;
    font-size: 16px;
  }
  #g-post14-teheranoil-sm .g-pstyle1 {
    font-weight: 300;
    line-height: 22px;
    height: 22px;
    font-size: 13px;
  }
  #g-post14-teheranoil-sm .g-pstyle2 {
    font-weight: 500;
    height: 15px;
    text-align: center;
  }
  #g-post14-teheranoil-sm .g-pstyle3 {
    font-weight: 500;
    height: 15px;
  }
  #g-post14-teheranoil-sm .g-pstyle4 {
    font-weight: 700;
    height: 15px;
    letter-spacing: 0.13em;
    font-size: 18px;
  }
  #g-post14-teheranoil-sm .g-pstyle5 {
    font-weight: 700;
    height: 15px;
    color: rgb(161, 54, 48);
  }
  #g-post14-teheranoil-sm .g-pstyle6 {
    font-weight: 400;
    height: 15px;
    color: rgb(161, 54, 48);
  }
  #g-post14-teheranoil-sm .g-pstyle7 {
    font-weight: 400;
    height: 15px;
    font-size: 14px;
    text-align: center;
    color: rgb(93, 93, 93);
  }
  #g-post14-teheranoil-sm .g-cstyle0 {
    font-weight: 300;
  }
  #g-post14-teheranoil-md {
    position: relative;
    overflow: hidden;
    display: none;
  }
  #g-post14-teheranoil-md p {
    font-family: var(--theme-font-family-sans-serif), Knowledge, sans-serif;
    font-weight: regular;
    line-height: 15px;
    height: auto;
    opacity: 1;
    letter-spacing: 0em;
    font-size: 15px;
    text-align: left;
    color: rgb(64, 64, 64);
    text-transform: none;
    padding-bottom: 0;
    padding-top: 0;
    mix-blend-mode: normal;
    font-style: normal;
    position: static;
  }
  #g-post14-teheranoil-md .g-pstyle0 {
    font-weight: 700;
    height: 15px;
    font-size: 16px;
  }
  #g-post14-teheranoil-md .g-pstyle1 {
    font-weight: 300;
    line-height: 23px;
    height: 23px;
    font-size: 12px;
  }
  #g-post14-teheranoil-md .g-pstyle2 {
    font-weight: 300;
    line-height: 23px;
    height: 23px;
    font-size: 11px;
  }
  #g-post14-teheranoil-md .g-pstyle3 {
    font-weight: 500;
    height: 15px;
    text-align: center;
  }
  #g-post14-teheranoil-md .g-pstyle4 {
    font-weight: 500;
    height: 15px;
  }
  #g-post14-teheranoil-md .g-pstyle5 {
    font-weight: 700;
    height: 15px;
    letter-spacing: 0.13em;
    font-size: 20px;
  }
  #g-post14-teheranoil-md .g-pstyle6 {
    font-weight: 700;
    line-height: 16px;
    height: 16px;
    color: rgb(161, 54, 48);
  }
  #g-post14-teheranoil-md .g-pstyle7 {
    font-weight: 400;
    line-height: 16px;
    height: 16px;
    color: rgb(161, 54, 48);
  }
  #g-post14-teheranoil-md .g-pstyle8 {
    font-weight: 400;
    height: 15px;
    font-size: 14px;
    text-align: center;
    color: rgb(93, 93, 93);
  }
  #g-post14-teheranoil-md .g-cstyle0 {
    font-weight: 300;
  }
  #g-post14-teheranoil-lg {
    position: relative;
    overflow: hidden;
    display: none;
  }
  #g-post14-teheranoil-lg p {
    font-family: var(--theme-font-family-sans-serif), Knowledge, sans-serif;
    font-weight: regular;
    line-height: 41px;
    height: auto;
    opacity: 1;
    letter-spacing: 0em;
    font-size: 16px;
    text-align: left;
    color: rgb(64, 64, 64);
    text-transform: none;
    padding-bottom: 0;
    padding-top: 0;
    mix-blend-mode: normal;
    font-style: normal;
    position: static;
  }
  #g-post14-teheranoil-lg .g-pstyle0 {
    font-weight: 700;
    line-height: 15px;
    height: 15px;
  }
  #g-post14-teheranoil-lg .g-pstyle1 {
    font-weight: 300;
    line-height: 26px;
    height: 26px;
    font-size: 14px;
  }
  #g-post14-teheranoil-lg .g-pstyle2 {
    font-weight: 300;
    line-height: 26px;
    height: 26px;
    font-size: 13px;
  }
  #g-post14-teheranoil-lg .g-pstyle3 {
    font-weight: 500;
    height: 41px;
    text-align: center;
  }
  #g-post14-teheranoil-lg .g-pstyle4 {
    font-weight: 500;
    height: 41px;
  }
  #g-post14-teheranoil-lg .g-pstyle5 {
    font-weight: 700;
    height: 41px;
    letter-spacing: 0.13em;
    font-size: 23px;
  }
  #g-post14-teheranoil-lg .g-pstyle6 {
    font-weight: 700;
    line-height: 18px;
    height: 18px;
    color: rgb(161, 54, 48);
  }
  #g-post14-teheranoil-lg .g-pstyle7 {
    font-weight: 400;
    line-height: 18px;
    height: 18px;
    color: rgb(161, 54, 48);
  }
  #g-post14-teheranoil-lg .g-pstyle8 {
    font-weight: 400;
    line-height: 28px;
    height: 28px;
    font-size: 14px;
    text-align: center;
    color: rgb(93, 93, 93);
  }
  #g-post14-teheranoil-lg .g-cstyle0 {
    font-weight: 300;
  }
  #g-post14-teheranoil-xl {
    position: relative;
    overflow: hidden;
    display: none;
  }
  #g-post14-teheranoil-xl p {
    font-family: var(--theme-font-family-sans-serif), Knowledge, sans-serif;
    font-weight: regular;
    line-height: 18px;
    height: auto;
    opacity: 1;
    letter-spacing: 0em;
    font-size: 14px;
    text-align: left;
    color: rgb(64, 64, 64);
    text-transform: none;
    padding-bottom: 0;
    padding-top: 0;
    mix-blend-mode: normal;
    font-style: normal;
    position: static;
  }
  #g-post14-teheranoil-xl .g-pstyle0 {
    font-weight: 400;
    height: 18px;
    font-size: 16px;
  }
  #g-post14-teheranoil-xl .g-pstyle1 {
    font-weight: 400;
    height: 18px;
  }
  #g-post14-teheranoil-xl .g-pstyle2 {
    font-weight: 400;
    height: 18px;
    font-size: 12px;
    color: rgb(102, 102, 102);
  }

  /* Custom CSS */
  @mixin shadow-emmental($clr) {
    $alpha: if(alpha($clr) != 1, alpha($clr), 1);
    text-shadow:
      -1px 0 rgba($clr, $alpha),
      0 1px rgba($clr, $alpha),
      1px 0 rgba($clr, $alpha),
      0 -1px rgba($clr, $alpha);
  }
  .g-shadowtext {
    @include shadow-emmental(#ffffff);
  }
  .g-numbersc {
    background-color: #000000;
    border-radius: 50%;
    border: 1px solid #ffffff;
    aspect-ratio: 1;
    width: 20px;
    display: flex;
    align-items: center;
    justify-content: center;
    color: #ffffff;
  }
</style>
